<template>
  <div id="footer" class="container-fluid">
    <div class="container yd">
      <div class="hidden-xs wow slideInUp">
        <div class="logo-bottom">
          <img src="@/assets/img/dbtb1.png" alt="成都英华科技有限公司" />
        </div>
        <div class="computer-info">
          <p class="address_tel_fax">
            <span @click="goMap" class="mapBai">网站地图&nbsp&nbsp</span>|
            <span
              >&nbsp&nbsp地址：四川省成都市高新区仁和春天国际广场A座20层&nbsp&nbsp</span
            >|
            <span>&nbsp&nbspTel：{{ phone }} </span>
          </p>
          <p class="copy">
            COPYRIGHT© 成都英华科技有限公司 &nbsp&nbsp&nbsp
            <a target="_blank" href="https://beian.miit.gov.cn"
              >蜀ICP备17012710号</a
            >
          </p>
        </div>
        <!-- <div class="wx-img">
          <img width="70" height="70" :src="wxImg" alt="成都英华科技有限公司" />
        </div> -->
      </div>
      <div class="visible-xs footer-yd">
        <p>COPYRIGHT© 成都英华科技有限公司</p>
        <p>
          Tel： <a href="tel:19180525510">{{ phone }}</a>
        </p>
        <p>
          网站备案：<a target="_blank" href="https://beian.miit.gov.cn"
            >蜀ICP备17012710号</a
          >
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { fileRecord } from "@/api/apiAll";
export default {
  name: "Footer",
  data() {
    return {
      wxImg: "",
      phone: "",
    };
  },
  mounted() {
    this.fileRecord("qr-code-pic");
    this.fileRecord("SET_PHONENUM");
  },
  methods: {
    goMap() {
      sessionStorage.setItem("dropIndex", 3);
      this.$store.commit("SET_DORPINDEX", 3);
      this.$router.push({
        path: "/software/address",
      });
    },
    fileRecord(code) {
      fileRecord({ code: code }).then((res) => {
        if (res.data.code === 0) {
          const list = res.data.data.fileList;
          if (code === "SET_PHONENUM") {
            this.phone = list.toString();
          } else {
            this.wxImg = list.toString();
          }
        }
      });
    },
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  height: 120px;
}
#footer .computer-info a {
  color: #b2b2b2;
  text-decoration: none;
}
#footer .computer-info {
  /* width: 60%; */
  float: left;
  margin-top: 37px;
}
#footer .logo-bottom {
  width: 70px;
  height: 46px;
  float: left;
  margin-top: 37px;
}
#footer .wx-img {
  width: 70px;
  height: 70px;
  float: right;
  margin-top: 25px;
}
.logo {
  width: 95px;
  height: 45px;
  /* margin: 50px auto 20px; */
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  width: 100%;
  color: #b2b2b2;
  font-size: 12px;
}
.mapBai {
  cursor: pointer;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  width: 100%;
  color: #b2b2b2;
  font-size: 12px;
  margin: 0px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
  }
}
@media screen and (max-width: 767px) {
  #footer {
    background: #e3e3e3;
    color: #555;
    font-size: 12px;
  }
  .yd {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .footer-yd {
    text-align: center;
    margin: 0 auto;
  }
  a {
    color: #555;
    text-decoration: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue